import React, { useEffect } from "react";
import MdaeTabPanel from "../../common_widgets/tab-panel";
import { Item } from "devextreme-react/tab-panel";
import EsmdCreateSubmissionTab from "./esmd-create-submission-tab";
import "./index.scss";
import { actions as asyncActions, callOperation } from "async-ops";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { GET_DRAFT_DOCUMENT } from "./services/get-draft-document";
import { isEqual } from "lodash";
import MdaeButton from "../../../common_components/common_widgets/button";
import { GET_CONTENT_TYPES } from "../../../pages/external-audit-setup/content-types/services/get-content-types";
import {
  SET_ESMD_SELECTED_TAB_INDEX,
  SET_SUBMISSION_NPI,
  TOGGLE_ESMD_SUBMISSION_WAIT_ALERT,
} from "./reducers/esmd-submission-reducer";
import {
  HIDE_LOADER,
  SHOW_LOADER,
  TOGGLE_NOTIFY_POPUP,
} from "../../mdae-common-reducer";
import { checkListIsEqual } from "../../mdae-framework";
import mdaeNotify, {
  NOTIFY_MESSAGE_TYPE,
} from "../../common_widgets/toast/notify";
import { SUBMIT_DOCUMENTS_TO_ESMD } from "./services/submit-documents-to-esmd";
import NotifyPopup, {
  NOTIFY_POPUP_TYPES,
} from "../../common_widgets/notify-popup";
import $ from "jquery";
import { GET_ESMD_SUBMISSSIONS } from "./services/get-esmd-submission";
import TrackEsmdSubmissionTab from "./track-submission";
import { checkIsPermOrQioReviewContractor, verifyPayerCaseId } from "../../../pages/external-audit/case-detail/case-data/component";
import { GET_ESMD_SUBMISSION_BY_AUDIT_ID } from "../../../pages/external-audit/services/get-esmd-submission-by-audit-id";
import { SET_ESMD_SUBMISSION_LIST } from "../../../pages/external-audit/reducers/external-audit-reducer";
import { getHighestZIndex } from "../../../app/ApplicationEventHandler";
import { RETRY_SUBMISSION } from "./services/retry-submission";
import { GET_CASE_NPI_OPTIONS } from "./services/get-case-npi-options";
const beforeWindowUnloadEventHandler = (event) => {
  event.preventDefault();
  return (event.returnValue = "Upload is in progress");
};
let waitTimeInterval: any = 0;
let currentWaitTime = 0;
const setupWaitTime = (dispatch) => {
  currentWaitTime = 0;
  waitTimeInterval = setInterval(function() {
    currentWaitTime += 1;
    if (currentWaitTime == 10) {
      clearInterval(waitTimeInterval);
      dispatch({
        type: TOGGLE_ESMD_SUBMISSION_WAIT_ALERT,
        data: {
          visible: true,
          height: "auto",
          width: 500,
          notifyOkButtonHandler: () => {
            window.open(window.location.href);
          },
          contentHtml: () => {
            return "This submission has taken longer than 10 seconds to upload. You can continue working in the new tab we have opened. Please do not close the tab where the submission is processing until you receive an submission success message.";
          },
          notifyPopupType: NOTIFY_POPUP_TYPES.ALERT,
          closeButtonText: "OK",
        },
      });
    }
  }, 1000);
};
function deleteWaitTimeSetup(dispatch) {
  dispatch({
    type: TOGGLE_ESMD_SUBMISSION_WAIT_ALERT,
    data: {
      visible: false,
    },
  });
  clearInterval(waitTimeInterval);
}
export const getNPIFromCompleteCaseDetail = (
  completeCaseDetail,
  caseDetailData
) => {
  const attendingProviderNtcs = completeCaseDetail.attendingProviderNtcs
    ? completeCaseDetail.attendingProviderNtcs
    : completeCaseDetail.attendingProviderNTCS
    ? completeCaseDetail.attendingProviderNTCS
    : ",,";

  const renderingProviderNtcs = completeCaseDetail.renderingProviderNtcs
    ? completeCaseDetail.renderingProviderNtcs
    : completeCaseDetail.renderingProviderNTCS
    ? completeCaseDetail.renderingProviderNTCS
    : ",,";

  let providerNpi = "";

  if (caseDetailData?.claimTypeCd?.toLowerCase() === "i") {
    providerNpi = attendingProviderNtcs.split(",")[0].trim();
  } else {
    providerNpi = renderingProviderNtcs.split(",")[0].trim();
  }
  return providerNpi;
};
export const submitDocumentsToESMD = (
  asyncAction,
  dispatch,
  data,
  completeCaseDetail,
  caseDetailData,
  isRetrySubmission = false
) => {
  window.addEventListener("beforeunload", beforeWindowUnloadEventHandler);
  dispatch({ type: SHOW_LOADER, data: { isManualLoaderShown: true } });
  setupWaitTime(dispatch);
  callOperation(
    isRetrySubmission ? RETRY_SUBMISSION : SUBMIT_DOCUMENTS_TO_ESMD,
    data
  ).then((response) => {
    deleteWaitTimeSetup(dispatch);
    window.removeEventListener("beforeunload", beforeWindowUnloadEventHandler);
    dispatch({ type: HIDE_LOADER, data: { isHideManualLoader: true } });
    response = response ? response : {};
    if (response.isAbilityError) {
      dispatch({
        type: TOGGLE_NOTIFY_POPUP,
        data: {
          visible: true,
          height: "auto",
          width: 550,
          contentHtml: () => {
            return (
              <div>
                {response.errors.map((x) => (
                  <div>{x.details}</div>
                ))}
              </div>
            );
          },
          notifyPopupType: NOTIFY_POPUP_TYPES.ERROR,
          closeButtonText: "Close",
        },
      });
    } else if (response.isSubmissionSuccessful) {
      mdaeNotify({
        message: "Submission Sent!",
        messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
      });
      asyncAction.asyncOperationStart(GET_ESMD_SUBMISSSIONS, {
        eaCaseId: caseDetailData?.eaCaseId,
      });
      asyncAction.asyncOperationStart(GET_DRAFT_DOCUMENT, {
        eaCaseId: caseDetailData?.eaCaseId,
      });
      dispatch({
        type: SET_ESMD_SELECTED_TAB_INDEX,
        data: {
          esmdSelectedTabIndex: 1,
        },
      });
      callOperation(GET_ESMD_SUBMISSION_BY_AUDIT_ID, {
        auditId: caseDetailData?.eaAuditId,
      }).then((response) => {
        dispatch({
          type: SET_ESMD_SUBMISSION_LIST,
          data: {
            esmdSubmissionListForAudit: Array.isArray(response) ? response : [],
          },
        });
      });
    }
  });
};
export const esMDSubmissionFileSize = {
  SUBMISSION_FILE_SIZE: "500",
};
export const ESMD_TAB = {
  ESMD_CREATE_SUBMISSION_TAB: 0,
  ESMD_TRACK_SUBMISSION_TAB: 1,
};
const EsmdCaseTab: React.FC<any> = () => {
  const dispatch = useDispatch();
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: asyncActions.asyncOperationStart,
    },
    dispatch
  );
  const caseDetailData = useSelector(
    (state) => state["caseDetailReducer"].caseDetailData,
    isEqual
  );
  const currentEaRound = useSelector(
    (state) => state["externalAuditReducer"].eaAuditRounds[0],
    isEqual
  );
  const auditPropertiesData = useSelector(
    (state) => state["auditPropertiesReducer"].auditPropertiesData,
    isEqual
  );
  const selectedEsmdSubmissionDocList = useSelector(
    (state) => state["esmdSubmissionReducer"].selectedEsmdSubmissionDocList,
    isEqual
  );
  const submissionEaContentTypeId = useSelector(
    (state) => state["esmdSubmissionReducer"].eaContentTypeId,
    isEqual
  );
  const esmdSelectedTabIndex = useSelector(
    (state) => state["esmdSubmissionReducer"].esmdSelectedTabIndex,
    isEqual
  );
  const draftDocumentList = useSelector(
    (state) => state["esmdSubmissionReducer"].draftDocumentList,
    checkListIsEqual
  );
  const completeCaseDetail = useSelector(
    (state) => state["caseDetailReducer"].completeCaseDetail,
    isEqual
  );
  const isCurrentRequesterReviewContractorValid = useSelector(
    (state) =>
      state["externalAuditReducer"].isCurrentRequesterReviewContractorValid,
    isEqual
  );
  const isCurrentContentTypeInvalidForReviewContractor = useSelector(
    (state) =>
      state["externalAuditReducer"]
        .isCurrentContentTypeInvalidForReviewContractor,
    isEqual
  );
  const contentTypeList = useSelector(
    (state) => state["esmdSubmissionReducer"].contentTypeList,
    isEqual
  );

  const caseData = useSelector(
    (state) => state["caseDataReducer"].caseData,
    isEqual
  );
  const selectedNpi = useSelector(
    (state) => state["esmdSubmissionReducer"].selectedNpi
  );
  const npiOptions = useSelector(
    (state) => state["esmdSubmissionReducer"].npiOptions
  );
  useEffect(() => {
    if (caseDetailData?.eaCaseId) {
      asyncAction.asyncOperationStart(GET_DRAFT_DOCUMENT, {
        eaCaseId: caseDetailData?.eaCaseId,
      });
      asyncAction.asyncOperationStart(GET_ESMD_SUBMISSSIONS, {
        eaCaseId: caseDetailData?.eaCaseId,
      });
    }
  }, [caseDetailData?.eaCaseId]);

  useEffect(() => {
    if (caseDetailData?.eaCaseId && caseDetailData?.eaAuditId) {
      asyncAction.asyncOperationStart(GET_CASE_NPI_OPTIONS, {
        eaCaseId: caseDetailData?.eaCaseId,
        eaAuditId: caseDetailData?.eaAuditId,
      });
    }
  }, [caseDetailData?.eaCaseId, caseDetailData?.eaAuditId]);

  useEffect(() => {
    if (npiOptions && npiOptions.length > 0) {
      const currentIsValid = selectedNpi && npiOptions.some((opt) => opt.npi === selectedNpi);
      if (!currentIsValid) {
        const emdrOption = npiOptions.find((opt) => opt.isEmdrNpi);
        if (emdrOption) {
          dispatch({ type: SET_SUBMISSION_NPI, data: emdrOption.npi });
        } else {
          const defaultNpi = getNPIFromCompleteCaseDetail(completeCaseDetail, caseDetailData);
          const matchingOption = defaultNpi ? npiOptions.find((opt) => opt.npi === defaultNpi) : null;
          if (matchingOption) {
            dispatch({ type: SET_SUBMISSION_NPI, data: matchingOption.npi });
          } else {
            dispatch({ type: SET_SUBMISSION_NPI, data: npiOptions[0].npi });
          }
        }
      }
    } else if (selectedNpi) {
      dispatch({ type: SET_SUBMISSION_NPI, data: "" });
    }
  }, [npiOptions]);


  useEffect(() => {
    asyncAction.asyncOperationStart(GET_CONTENT_TYPES, {});
  }, []);
  const onEsmdDocSubmitClick = () => {
    if (
      !verifyPayerCaseId(
        caseData?.payerCaseId,
        caseData?.rqstrRecordSubmissionValue
      )
    ) {
      const isPermOrQioReviewContractor = checkIsPermOrQioReviewContractor(
        caseData?.rqstrRecordSubmissionValue
      );

      const fieldName = isPermOrQioReviewContractor
        ? "Payer Case ID"
        : "Payer Claim ID";
      var message = fieldName + " not found.";
      if (caseData?.payerCaseId) {
        message = fieldName + " is invalid.";
      }
      mdaeNotify({
        message: message,
        messageType: NOTIFY_MESSAGE_TYPE.ERROR,
      });
      return;
    }
    if (
      !isCurrentRequesterReviewContractorValid &&
      isCurrentContentTypeInvalidForReviewContractor
    ) {
      mdaeNotify({
        message: isCurrentRequesterReviewContractorValid
          ? "You are unable to Create or Send a submission with an invalid Content Type selected. Please update the Content Type for the Review Contractor associated with your Requester"
          : "You are unable to Create or Send a submission with an invalid Review Contractor selected. Please update the Review Contractor associated with your Requester.",
        messageType: NOTIFY_MESSAGE_TYPE.ERROR,
      });
      return;
    }
    if (
      !(
        selectedEsmdSubmissionDocList &&
        selectedEsmdSubmissionDocList.length > 0
      )
    ) {
      mdaeNotify({
        message: "Please select atleast one document.",
        messageType: NOTIFY_MESSAGE_TYPE.ERROR,
      });
      return;
    }
    var totalSize = 0;
    for (let i = 0; i < selectedEsmdSubmissionDocList.length; i++) {
      totalSize += selectedEsmdSubmissionDocList[i].fileSize;
    }
    totalSize = totalSize / (1024 * 1024);
    if (totalSize > 500) {
      mdaeNotify({
        message:
          "You have reached the 500 MB per submission limit. Additional documents will need to be sent in a separate Submission",
        messageType: NOTIFY_MESSAGE_TYPE.ERROR,
      });
      return;
    }

    if (!selectedNpi) {
      mdaeNotify({
        message: "Please select an NPI.",
        messageType: NOTIFY_MESSAGE_TYPE.ERROR,
      });
      return;
    }
    let providerNpi = selectedNpi;

    if (!caseData?.rqstrRecordSubmissionValue) {
      mdaeNotify({
        message: "Review contractor not found.",
        messageType: NOTIFY_MESSAGE_TYPE.ERROR,
      });
      return;
    }
    const selectedContentTypeCode = contentTypeList.find(
      (x) => x.eaContentTypeId == submissionEaContentTypeId
    )?.eaContentTypeCode;

    if (!selectedContentTypeCode) {
      mdaeNotify({
        message: "Content type not found.",
        messageType: NOTIFY_MESSAGE_TYPE.ERROR,
      });
      return;
    }



    const data = {
      esmdDocumentUploadList: selectedEsmdSubmissionDocList,
      eaCaseId: caseDetailData?.eaCaseId,
      payerCaseId: caseData?.payerCaseId,
      eaRequesterId: caseData?.requesterId,
      eaRoundId: caseData?.eaRoundId,
      referenceId: auditPropertiesData?.referenceId,
      eaContentTypeCode: selectedContentTypeCode,
      reviewContractorCode: caseData?.rqstrRecordSubmissionValue,
      npi: providerNpi,
      payerClaimControlNo: caseData?.payerClaimControlNo
    };
    submitDocumentsToESMD(asyncAction, dispatch, data, completeCaseDetail, caseDetailData);
  };

  return (
    <div>
      {draftDocumentList.length > 0 &&
        caseData?.rqstrRecordSubmissionMethod?.toLowerCase() == "esmd" &&
        esmdSelectedTabIndex == ESMD_TAB.ESMD_CREATE_SUBMISSION_TAB && (
          <div className="send-button-section">
            <MdaeButton
              id={"btnSendToEsMD"}
              className={"send-button"}
              role={"primary"}
              text={
                selectedEsmdSubmissionDocList?.length > 0
                  ? selectedEsmdSubmissionDocList?.length == 1
                    ? `Send ${selectedEsmdSubmissionDocList.length} Document`
                    : `Send (${selectedEsmdSubmissionDocList.length}) Documents`
                  : `Send Documents`
              }
              icon="fas fa-paper-plane paper-plane-style"
              validationGroup="esMdValidationGroup"
              onClick={onEsmdDocSubmitClick}
            ></MdaeButton>
          </div>
        )}
      <MdaeTabPanel
        id="esmdCaseTabPanel"
        deferRendering={false}
        selectedIndex={esmdSelectedTabIndex}
        onSelectionChanged={(e) => {
          let selectedIndex = e.component.option("selectedIndex");
          dispatch({
            type: SET_ESMD_SELECTED_TAB_INDEX,
            data: {
              esmdSelectedTabIndex: selectedIndex,
            },
          });
        }}
      >
        <Item
          title={"Create Submission"}
          visible={
            caseData?.rqstrRecordSubmissionMethod?.toLowerCase() == "esmd"
          }
        >
          <EsmdCreateSubmissionTab />
        </Item>
        <Item title={"Track Submission"}>
          <TrackEsmdSubmissionTab></TrackEsmdSubmissionTab>
        </Item>
      </MdaeTabPanel>
      <NotifyPopup
        id={"esmd-submission-wait-time-warning"}
        actionType={TOGGLE_ESMD_SUBMISSION_WAIT_ALERT}
        onShown={(e) => {
          setTimeout(() => {
            $(e.component.content())
              .parents(".dx-overlay-content")
              .css("z-index", getHighestZIndex());
            $(e.component.content())
              .parents(".dx-overlay-wrapper")
              .css("z-index", getHighestZIndex());
          }, 100);
        }}
        widgetConfigPropertyName={"esmdUploadWaitWarnigPopupConfig"}
        reducerName={"esmdSubmissionReducer"}
      ></NotifyPopup>
    </div>
  );
};

export default EsmdCaseTab;
